
define('jst!notifications/tour/_step3',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Viewed #featuretour") %></h1>\n\n<p><%= t("Notifications you\'ve already seen are moved to \'Viewed\' automatically. #featuretour") %></p>\n\n\n');
 });

